module.exports = __webpack_public_path__ + "img/tp-8.718f3ce2.png";